function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import SelectDropdown from '../../Fields/SelectDropdown';
import FormManager from '../../FormManager';
import Input from '../../FormManager/Input';
import ModalForm from '../../Modal/Form';
import Toaster from '../../Toaster';
import React, { forwardRef, useRef } from 'react';
import { useAuthAPI } from '../../../common/hooks/useAuthAPI';
import branding from '@config/branding';
import Button from '../../Button';
import Icon from '../../Icon';
import classNames from 'classnames';
import { useFormField } from 'formydable';
import './index.scss';
const InputWithAdd = /*#__PURE__*/forwardRef(({
  as: Component = SelectDropdown.Graph,
  responsePKKey,
  buttonInputGroup,
  buttonProps,
  modalFormProps: {
    endpoint,
    managePayload,
    getToasterName,
    onResponse,
    onError,
    onRefetchGraph,
    ...modalFormProps
  },
  ...props
}, ref) => {
  const {
    setFieldValue
  } = useFormField();
  const dropdownGraphRef = useRef(null);
  const requestAdd = useAuthAPI(endpoint);

  const handleAdd = _ => {
    const recursivePromptForm = () => {
      ModalForm({ ...modalFormProps
      }).then(event => {
        if (event.isSubmit) {
          const FORM_DATA = event.json();
          const payload = managePayload(FORM_DATA);
          const name = getToasterName(FORM_DATA);
          const toast = Toaster(`Saving ${name}`);
          requestAdd.call({
            data: payload
          }).then(response => {
            if (response.data.success) {
              event.closeModal();
              toast.success(`Successfully saved ${name}`);
              dropdownGraphRef.current?.refetch().then(data => {
                setFieldValue(props.name, response.data[responsePKKey] || '');

                if (onRefetchGraph) {
                  onRefetchGraph(data);
                }
              });
            } else {
              toast.fail(response.data.message || branding.messages.fail);
              FormManager.setBackendValidation(event, response.data.errors);
              event.setValidationMessages(response.data.errors?.map(error => error.errorMessage));
              recursivePromptForm();
            }

            if (onResponse) {
              onResponse(response);
            }
          }).catch(error => {
            recursivePromptForm();
            event.setError(error?.response.data.message || branding.messages.error);
            toast.error();

            if (onError) {
              onError(error);
            }
          }).finally(() => {
            event.removeLoading();
          });
        }
      });
    };

    recursivePromptForm();
  };

  return (
    /*#__PURE__*/
    //@ts-ignore
    React.createElement(Input, _extends({
      ref: target => {
        dropdownGraphRef.current = target;

        if (ref) {
          ref.current = target;
        }
      },
      as: Component
    }, props, {
      [buttonInputGroup ? 'append' : 'formGroupAppend']: /*#__PURE__*/React.createElement(Button, _extends({
        type: "button"
      }, buttonProps, {
        className: classNames(buttonInputGroup ? '' : 'btn-input-add', null, buttonProps?.className),
        onClick: handleAdd
      }))
    }))
  );
});
InputWithAdd.defaultProps = {
  buttonInputGroup: false,
  responsePKKey: 'primaryKey',
  buttonProps: {
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      name: "plus"
    }), " Add")
  }
};
export default InputWithAdd;